<template>

  <div>


    <PageHeader :title="chapter ? 'Edit \'' + chapter.title + (editType === 'image' ? '\' Images' : '\' Micro Notes') : 'Loading...'">

      <div v-if="microNotes && microNotes.length" style="float: right;width:100%;" class="email-filters-right  text-right xs-mt-10">
        <ol class="breadcrumb" style="margin-top: 3px; float:left;">
          <li><router-link :to="{name: 'subject-shelf'}"><i class="icon mdi mdi-arrow-left"></i> &nbsp;Home</router-link></li>
        </ol>

        <span class="email-pagination-indicator">{{currentMicroNoteIndex + 1}} of {{microNotes.length}}&nbsp;</span>
        <div class="btn-group email-pagination-nav text-right">
          <button v-on:click.prevent="previousMicroNote" type="button" class="btn btn-default" title="Previous micro note"><i class="mdi mdi-chevron-left"></i><span class="xs-hide"> Prev</span></button>
          <button v-on:click.prevent="nextMicroNote" type="button" class="btn btn-default" title="Next micro note"><span class="xs-hide">Next </span><i class="mdi mdi-chevron-right"></i></button>
        </div>
        <button v-on:click.prevent="addMicroNote" type="button" class="btn btn-primary" title="Add new micro note"><i class="fas fa-plus" style="font-size:14px;"></i> Add<span class="xs-hide"> micro note</span></button>
        <button v-on:click.prevent="toggleDeleteWarning" type="button" class="btn btn-danger" title="Delete this micro note"><i class="fas fa-trash" style="font-size:14px;"></i> Delete<span class="xs-hide"> micro note</span></button>


        <div class="clearfix"></div>
        <div class="pull-left text-left">
          <div>
            <Help>
              <div slot="content">
                <div v-if="editType !== 'image'">
                  Split your lecture notes into micro notes with the <span class="btn btn-default"><span class="fa fa-minus"></span></span> button. Select keywords to be hidden/tested with the <span class="btn btn-default"><span class="fa fa-key"></span></span> button.<br />
                  Click an image and select <span class="btn btn-default"><span class="fa fa-object-group"></span></span> to convert the image to a micro note. Image keywords can be set in the next stage.<br />
                  Click <span class="btn btn-default"><span class="fa fa-save"></span> Create micro notes</span> to save and proceed to micro note image editing.
                </div>
                To create image keywords, click and drag on the image to create a keyword area then type in your keyword.<br/>
                You can re-size or move image keywords once created.<br />
                Jump to the next/previous micro note with <span class="btn btn-default"><i class="mdi mdi-chevron-left"></i></span> and <span class="btn btn-default"><i class="mdi mdi-chevron-right"></i></span>. <strong>Changes are saved automatically</strong>
              </div>
            </Help>
          </div>
        </div>

        <div class="pull-right">
          <div class="active-toggle">
            <span class="lbl">Micro note is:</span>
            <BoolSwitch :toggle-bool="microNoteActive" :toggle-function="toggleActive" on-text="On" off-text="Off"></BoolSwitch>
          </div>

          <KeywordSettings :chapterId="microNote.chapter_id" class="xs-mt-10" />
        </div>
      </div>
      <div class="clearfix"></div>

      <div v-if="showDeleteWarning" class="bg-danger clearfix">
        <p class="pull-left">
          Are you sure you want to delete this micro note?
        </p>
        <div class="pull-right">
          <a v-on:click.prevent="deleteMicroNote" href class="btn btn-default btn-sm" style="float: right">
            Delete
          </a>
          <a v-on:click.prevent="toggleDeleteWarning" href class="btn btn-default btn-sm btn-margin" style="float: right">
            Cancel
          </a>
        </div>
      </div>
    </PageHeader>


    <div class="main-content container-fluid">
      <!-- Falsey states -->
      <div class="row" v-if=" !chapter || !microNotes || !microNotes.length || !microNote">
        <div class="col-md-12">
          <Panel>
            <PanelBody>
              <LoadingIndicator v-if="!chapter" />
              <p v-else-if=" !microNotes || !microNotes.length"><em>There are no micro notes in this chapter.</em></p>
              <p v-else-if=" !microNote"><em>Micro note not found.</em></p>
            </PanelBody>
          </Panel>
        </div><!-- /.col -->
      </div><!-- /.row -->
      <!-- HTML Editor -->
      <div v-else-if="microNote.micro_note_type === 'html'" class="row height-100">
        <div class="col-md-12 height-100">
          <div class="height-100">
            <FroalaEditor @change="saveMicroNote" :chapterId="microNote.chapter_id" ref="editor" :config="froalaConfig" v-model="newHtml" />
            <p class="text-muted">{{statusMessage}}</p>
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
      <!-- Image Editor -->
      <div v-else class="row">
        <div class="col-md-12">
          <Panel class="panel panel-default">
            <PanelBody style="padding: 20px; text-align: center;">
              <MicroNoteImageEditor :microNote="microNote" />
            </PanelBody>
          </Panel>
        </div><!-- /.col -->
      </div><!-- /.row -->


    </div><!-- /.main-content -->
  </div>

</template>


<script>
import _ from 'underscore'
import froalaConfig from '../froala-editor/config/micro-note-editor.js'
import Chapter from '../../resources/chapter'
import MicroNote from '../../resources/microNote'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import router from '../../router'
import MicroNoteImageEditor from './MicroNoteImageEditor'
import FroalaEditor from '../froala-editor/FroalaEditor'
import KeywordSettings from './KeywordSettings'
import BoolSwitch from '../shared/controls/BoolSwitch'

export default {
  components: {
    FroalaEditor,
    MicroNoteImageEditor,
    KeywordSettings,
    BoolSwitch,
  },

  created() {
    this.getChapters();
    this.getMicroNotes();
  },

  methods: {
    ...mapActions(['getMicroNotes', 'getChapters']),

    nextMicroNote() {
      let nextIndex = this.currentMicroNoteIndex + 1;
      if( !this.microNotes[nextIndex]) nextIndex = 0;
      this.currentMicroNoteIndex = nextIndex;
    },

    previousMicroNote() {
      let nextIndex = this.currentMicroNoteIndex - 1;
      if( !this.microNotes[nextIndex]) nextIndex = this.microNotes.length - 1;
      this.currentMicroNoteIndex = nextIndex;
    },

    toggleDeleteWarning() {
      this.showDeleteWarning = !this.showDeleteWarning;
    },

    deleteMicroNote() {
      this.$store.dispatch('deleteMicroNote', { micronote: this.microNote, callback: (err) => {
          if(err) {
            Toast.error(err);
          } else {
            Toast.success('Micro note deleted');
            this.toggleDeleteWarning();
            if(this.microNotes.length > 0) {
              this.nextMicroNote();
            } else {
              router.push({ name: 'subject-shelf' });
            }
          }
        }
      });
    },

    addMicroNote() {
      this.status = 'Creating micro note';
      this.$store.dispatch('createMicroNote', {
        microNote: {
          chapter_id: this.chapter.id,
          html: '<p>Enter your study notes here.</p><p>Keywords display <keyword>like this</keyword>.</p>',
          micro_note_type: 'html'
        },
        callback: (err) => {
          // #todo - error
          this.status = 'saved';
          this.currentMicroNoteIndex = this.microNotes.length-1;
        },
      });
    },

    saveMicroNote() {
      this.status = 'saving';
      const changes = Object.assign({}, this.microNote, { html: this.newHtml, active: this.microNoteActive });
      this.$store.dispatch('updateMicroNote', {
        id: this.microNote.id,
        changes,
        callback: (err) => {
          // #todo - error
          this.status = 'saved';
        },
      });
    },

    toggleActive(value) {
      this.microNoteActive = value;
      this.saveMicroNote();
    }
  },

  data() {
    return {
      // chapter: null, // no need for a store since really only this component and it's children are concerned with it (I think?)
      currentMicroNoteIndex: 0,
      newHtml: '', // changes are applied to this first (we can't directly mutate state)
      microNoteActive: true,

      froalaConfig: Object.assign({}, froalaConfig, {
        height: 'calc(100% - 55px)',
      }),

      status: null, // saving status
      showDeleteWarning: false,
    }
  },


  watch: {
    // When we change microNotes, reset this.newHtml
    microNote(newMicroNote, oldMicroNote) {
      const newId = newMicroNote ? newMicroNote.id : null;
      const oldId = oldMicroNote ? oldMicroNote.id : null;

      // the 2nd conditon is there for the initial lode (new and old ID is the same, but we still want to set this.newHtml)
      if ((newId && newId != oldId) || (!this.newHtml && newMicroNote)) {
        // console.log('setting this.newHtml')
        this.newHtml = newMicroNote.html;
        this.microNoteActive = newMicroNote.active;

        if (this.microNoteActive === null) { this.microNoteActive = true; }
      }
    },
  },


  computed: {
    statusMessage() {
      if( !this.microNote) return '';
      if(this.status === 'saving') {
        return 'Saving...';
      } else if(this.status === 'saved') {
        return 'Changes saved.';
      } else {
        return `Last saved ${moment(this.microNote.updated_at).fromNow()}`;
      }
    },

    chapter() {
      return this.$store.state.chapters[this.$route.params.chapterId];
    },

    editType() {
      if(this.$route.params.editType) {
        return this.$route.params.editType;
      }
      return 'all';
    },

    microNotes() {
      const chapterId = parseInt(this.$route.params.chapterId);
      if( !chapterId) return [];
      const allMicroNotes = this.$store.getters.allMicroNotes;

      let filter = {chapter_id: chapterId}
      if(this.editType !== 'all') {
        filter.micro_note_type = this.editType;
      }
      const microNotes = _.where(allMicroNotes, filter);
      return microNotes;
    },

    // The *current* microNote we're editing
    microNote() {
      if (!this.chapter) return null;
      if (!_.isArray(this.microNotes)) return null;
      return this.microNotes[this.currentMicroNoteIndex];
    },
  },
}
</script>


<!-- Scoped styling -->
<style lang="scss" scoped>
  .height-100 {
    height: 100%;
  }

.main-content {
  height: calc(100vh - 180px);
}

  @media only screen and (max-width: 600px) {
    .xs-hide {display:none;}
  }
</style>

<style lang="scss">
/**
 * Styling for <keyword> as shown in editor (scoped doesn't work for sum reazon)
 */
keyword {
  background: #fcd45e;
  padding: 5px;
  border-radius: 4px;
}

  .keyword-settings {margin-top:10px;float:left;}
  .active-toggle { float: left; margin-top: 11px; margin-right:20px;}
  .active-toggle .lbl {display:inline-block;margin:3px 5px;}

  .bg-danger { color:#FFFFFF; padding: 15px; margin-bottom: 5px; }

    .bg-danger p { margin-bottom: 0; width: calc(100% - 150px); }
  .bg-danger .btn {margin-left:10px;}
</style>



// WEBPACK FOOTER //
// MicroNoteEditor.vue?736ad341